// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { getProductByPath } from "@store/Extensions/Services/ProductServiceV2";
import { addToChainAfter, createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    props.apiParameter.expand?.push("properties");
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getProductByPath(props.apiParameter) /* Greif - import from Extensions */;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        const { storefrontAccess } = getSettingsCollection(props.getState()).productSettings;
        if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
            // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
        }

        throw error;
    }
});
